import { defineComponent as _defineComponent } from 'vue'
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import type { Maybe } from '@/helpers/types';
import type { PosterSponsoredRecImages } from '@/interfaces/components/poster/PosterGraphql';

import { computed } from 'vue';
import { BackgroundImageSize } from '@/@types/graphql-types';
import { SingleTitleSR } from '@/features/sponsored-recommendations/types';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import PictureComp from '@/components/picture/PictureComp.vue';

type ImageObject = { [key in BackgroundImageSize]: string };

export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationImageSearch',
  props: {
    sponsoredAdCampaign: null,
    lazy: { type: Boolean, default: true },
    additionalContexts: { default: () => [] },
    isCinemaSR: { type: Boolean, default: false },
    showPoster: { type: Boolean, default: false }
  },
  emits: ["onPosterClickOut", "imageError"],
  setup(__props: any) {

const props = __props as { sponsoredAdCampaign: NonNullable<SponsoredAdFragment['campaign']> & { node: SingleTitleSR }, lazy: boolean, additionalContexts: SnowplowContext[], isCinemaSR: boolean, showPoster: boolean };





const campaignNode = computed(() => props.sponsoredAdCampaign.node);
const backgroundImages = computed(() => {
	const imageSizes: ImageObject = {} as ImageObject;

	props.sponsoredAdCampaign?.backgroundImages?.map(options => {
		if (!options?.size) {
			return;
		}

		imageSizes[options.size] = options?.imageURL;
	});

	return imageSizes;
});

const posterPath = computed(() => props.sponsoredAdCampaign.node.content.fullPath);

const posterImageOverride = computed<PosterSponsoredRecImages | null>(() => {
	let posterUrl = props.sponsoredAdCampaign?.posterOverride || campaignNode.value.content.posterUrl;
	if (!posterUrl) return null;

	if (posterUrl.startsWith('/')) {
		posterUrl = `${JW_CONFIG.IMAGESCALER_URL}${posterUrl.replace('{profile}', 's332')}`;
	}

	return {
		imageUrl: posterUrl,
		sourceSets: [
			{
				srcSet: posterUrl.replace(/\.{?\w+}?$/, '.avif'),
				imageProp: {
					extension: '.avif',
					type: 'image/avif',
				},
				sourceProp: {
					viewport: 'desktop',
				},
				media: null,
			},
		],
	};
});

return { __sfc: true,props, campaignNode, backgroundImages, posterPath, posterImageOverride, PictureComp }
}

})